<template>
  <div id="app">

    <app-nav />
    
    <main id="page-wrap">

      <backup-nav></backup-nav>

      <div id="overlay" />
      <div id="main">

        <!-- <transition name="fade" mode="out-in"
        v-on:before-enter="beforeEnter"
        v-on:enter="enter"
        v-on:after-enter="afterEnter"
        v-on:enter-cancelled="enterCancelled"

        v-on:before-leave="beforeLeave"
        v-on:leave="leave"
        v-on:after-leave="afterLeave"
        v-on:leave-cancelled="leaveCancelled">
          <router-view />
        </transition> -->

        <transition name="fade" mode="out-in">
          <router-view />
        </transition>

      </div>

    </main>

  </div>
</template>

<script>
import BackupNav from './components/BackupNav.vue'
import AppNav from './components/Nav.vue'

export default {
  components: { BackupNav, AppNav },
  methods: {
    // --------
    // ENTERING
    // --------

    beforeEnter: function (el) {
      // ...
    },
    // the done callback is optional when
    // used in combination with CSS
    enter: function (el, done) {
      // ...
      done()
    },
    afterEnter: function (el) {
      // ...
    },
    enterCancelled: function (el) {
      // ...
    },

    // --------
    // LEAVING
    // --------

    beforeLeave: function (el) {
      // ...
    },
    // the done callback is optional when
    // used in combination with CSS
    leave: function (el, done) {
      // ...
      done()
    },
    afterLeave: function (el) {
      // ...
    },
    // leaveCancelled only available with v-show
    leaveCancelled: function (el) {
      // ...
    }
  }
}

</script>

<style lang="scss">

@import "@/assets/styles/_normalize.scss";
@import "@/assets/styles/_fonts.scss";

.fade-enter-active, .fade-leave-active {
  transition: opacity .25s ease-out, transform .25s ease-out;
}

.fade-enter {
  opacity: 0;
  //transform: translateY(-50px);
}

.fade-leave-to {
  opacity: 0;
  //transform: translateY(50px);
}

body {
  margin: 0;
  // overflow: hidden;
  overflow-x: hidden;
  overflow-y: auto;
}

#app {
  width: 100vw;
  // height: 100vh;
  height: auto;
  display: flex;

  background-color: $gray1;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%237B8794' fill-opacity='0.25'%3E%3Cpath opacity='.5' d='M96 95h4v1h-4v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9zm-1 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9z'/%3E%3Cpath d='M6 5V0H5v5H0v1h5v94h1V6h94V5H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}

#main {
  flex: 1;
  // overflow-y: hidden;
  overflow-x: hidden;
  overflow-y: auto;
  @include phone-only {
    margin-left: 0;
  }
}

#page-wrap {
  width: 100vw;
}

* {
  font-family: $body-font;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1, h2, h3, h4, h5, h6, a, li, p {
  color: inherit;
  margin: 0;
}

p {
  font-family: $body-font;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 160%;
  letter-spacing: .02em;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb {
  background-color: $gray8;
  border-radius: 10px;
}

.letter {
  font-family: $title-font;
  transform-origin: 0 100%;
  display: inline-block;
  line-height: 1em;
}

.grid-item {
  background: $white;
  box-shadow: $standard-shadow;
}

img[lazy=loading] {
  max-width: 64px;
}

.VueCarousel-slide {
  img {width: 100%;}
}

.VueCarousel-dot {
  padding: 2px 6px !important;
}

.VueCarousel-navigation-button {
  color: $gray6 !important;
  
  @include phone-only {
    display: none !important;
  }
}

@supports (-ms-ime-align: auto) {
  #overview, #about-preview {
    background-image: none !important;
    background-color: $gray8 !important;
  }

  .card-bg {
    display: none !important;
  }
}
</style>
